<template>
  <div class="pc_conments">
    <ul class="ulList" v-if="tableData.list.length>0">
      <li class="liItem" v-for="(item,i) in tableData.list" :key="i" @click="popup(item.sid)">
        <div>
          <div class="supExhTitle">
            <div class="leftLogo">
              <img :src="item.img" alt="" />
            </div>
            <div class="rightTitle">
              <p>
                {{item.name?item.name:item.nickname}}
                <span>{{item.duties}}</span>
                <img v-if="item.authent*1==1" :src="hrefurl+'/public/icon/attestation.jpg'" alt=""/>
              </p>
              <p>
                {{item.corpname}}
              </p>
            </div>
          </div>
          <p class="pc_conmentContent">
            {{item.content}}
          </p>
          <span class="sanjiao"></span>
        </div>
        <div >
          <div class="leftLogo1">
            <img :src="item.comment_img" alt="" />
          </div>
          <div class="rightTitle1">
            <p>
              <span>{{item.comment_name?item.comment_name:item.comment_nickname}}</span>
              <span>{{item.ctime}}</span>
            </p>
            <p class="pc_conmentContent1">
              {{item.comment}}
            </p>
          </div>
          <div @click.stop>
            <el-popconfirm
              confirm-button-text="Confirm"
              cancel-button-text="Cancel"
              title="Are you sure to cancel?"
              @onConfirm='cancel(item.id)'
            >
              <el-button class="del" type="danger" slot="reference">Delete</el-button>
            </el-popconfirm>
          </div>
          <!-- <el-button  >删除</el-button> -->
        </div>
      </li>
    </ul>
    <div class="null" v-else>
      <div>
        <img :src="hrefurl+'/public/icon/without.png'" alt=""/>
      </div>
      No data is available!
    </div>
    <el-pagination
      v-if="tableData.listnum>tableData.pagelistnum"
      @current-change="handleCurrentChange"
      :current-page="tableData.pagelistnum"
      :page-size="tableData.pagelistnum"
      layout="total, prev, pager, next "
      :pager-count="5"
      prev-text="prev"
      next-text="next"
      :total="tableData.listnum * 1"
    >
    </el-pagination>
    <el-dialog
      title="详情"
      :visible.sync="centerDialogVisible"
      width="70%"
      top="3vh"
      :before-close="beforeClose"
      center>
        <div class="comment" v-if="detailsList[0]">
          <div class="userMessage">
            <div>
              <img :src="detailsList[0].img" alt="" />
              <span class="name">{{detailsList[0].name?detailsList[0].name:detailsList[0].nickname}}</span>
              <span>{{detailsList[0].duties}}</span>
              <span>{{detailsList[0].corpname}}</span>
              <span>{{detailsList[0].ctime}}</span>
            </div>
          </div>
          <p>{{detailsList[0].content}}</p>
          <div v-if="detailsList[0].address" class="address">
            <img class="imgIcon" :src="hrefurl+'/public/icon/address.png'" alt="" />
            {{detailsList[0].address}}
          </div>
          <div v-if="detailsList[0].supply_img" class="commentImg" ref="commentImg">
            <div class="userImg" ref="userImg">
              <div v-for="(item,i) in detailsList[0].supply_img" :key="i">
                <img :src="item.img_url" :alt="item.img_info_cn" /> 
              </div>
            </div>
          </div>
          
        </div>
        <div class="area" >
          <ul class="areaList" v-if="detailsList[1]">
            <li class="areaItem" v-for="(areaItem,i) in detailsList[1]" :key="'area'+i">
              <img :src="areaItem.img" alt="" />
              <div class="con">
                <span class="areaName">{{areaItem.name?areaItem.name:areaItem.nickname}}：</span>
                <span class="areaContent">{{areaItem.comment}}</span> 
                <p>
                  <span class="areaTime">{{areaItem.ctime}}</span>
                  <span class="praise">99</span>
                </p>
              </div>
              <div class="cancel" style="display:none">
                <el-popconfirm
                  icon="el-icon-info"
                  icon-color="red"
                  confirm-button-text="Confirm"
                  cancel-button-text="Cancel"
                  title="Are you sure to cancel?"
                  @onConfirm='del(areaItem.id)'
                >
                  <el-button slot="reference" type="danger">Delete</el-button>
                </el-popconfirm>
              </div>
            </li>
          </ul>
          <div class="discussArea">
            <textarea class="discuss" placeholder="Input Message" name="" id="" cols="30" rows="10" v-model="content"></textarea>
            <button @click="sendComment">Send</button>
          </div>
        </div>
    </el-dialog>
  </div>
</template>

<script>
import { reqMyComment, reqMyCommentDel, reqComment, reqComments } from "../../../../api";
export default {
  components:{
  },
  data(){
    return{
      tableData:{
        listnum:0,
        pagelistnum:0,
        list:[],
      },
      detailsList:{},
      centerDialogVisible:false,
      current:0,
      content:''
    }
  },
  mounted(){
    this.init()
  },
  methods:{
    async init(p=1){
      const response = await reqMyComment(p)
      if (response.code*1==2) {//请求成功 有数据
        this.tableData={
          listnum:response.listnum,
          pagelistnum:response.pagelistnum,
          list:response.reslist
        }
      }else if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"Timeout, please try...")
      }
    },
    handleCurrentChange(p){
      this.init(p)
    },
    async cancel(id){
      const response = await reqMyCommentDel(id)
      if (response.code*1==2) {//请求成功 有数据
        let index = this.tableData.list.findIndex(item=>item.id==id)
        if (index>=0) this.tableData.list.splice(index,1)
        this.success(this,'Delete Successfully!')
      }else if (response.code*1==0) {//未登录
        this.$store.dispatch('outLogin')
        this.$router.push("/home")
        this.$store.dispatch('dialog',true)
        this.err(this,"Timeout, please try...")
      }
    },
     
    async popup(id){// 详情页弹窗请求
      
      const response = await reqComment(id)
      if (response.code==1) {
        this.detailsList=response.msg
        this.centerDialogVisible=true
        this.current = id
      }
    },
    beforeClose(){
      this.content = ''
      this.centerDialogVisible=false
    },
    async sendComment(){//发送评论
      let cent = this.content.trim()
      let isLogin = this.jump(this)
      // 当前用户id：this.user.id;
      //当前选中动态的id：this.current
      if (!cent.length&&!isLogin) return
      // 发送请求
      const response = await reqComments({sid:this.current,comment:this.content})
      if (response.code==1) {
        this.success(this,'评论提交成功，请耐心等待审核。。。')
        this.content=""
      } else if(response.code==0) {
        this.err(this,'评论失败，请稍后重试。。。')
      }else if(response.code==2){
        this.err(this,'登录失效，请重新登录。。。')
        // this.jump(this)
        this.$store.dispatch("outLogin")
        this.$store.dispatch("dialog",true)

      }
    },
  }
}
</script>

<style scoped>
  .ulList{
    /* background-color: white; */
    padding: 10px;
  }
  .liItem{
    width: 100%;
    /* padding: 20px; */
    overflow: hidden;
    margin-bottom: 30px;
    cursor: pointer;
  }
  .liItem>div:first-child{
    position: relative;
    padding: 10px;
    background-color: #e6e4e5;
  }
  .supExhTitle{
    display: flex;
  }
  .leftLogo{
    width: 60px;
    border-radius: 50%;
    overflow: hidden;
    /* padding: 20px; */
    margin-right: 10px;
  }
  .rightTitle{
    line-height: 30px;
    font-size: 16px;
  }
  .rightTitle>p>span{
    margin: 0 10px;
  }
  .rightTitle>p>img{
    width: 80px;
    height: 20px;
  }
  .pc_conmentContent{
    padding: 10px;
    letter-spacing:.1em;
    font-size: 14px;
  }
  .sanjiao{
    position: absolute;
    bottom: 0;
    left: 30px;
    width: 0;
    height: 0;
    border-top: 10px solid transparent;
    border-right: 10px solid transparent;
    border-bottom: 10px solid #fafafa;
    border-left: 10px solid transparent;
  }
  .liItem>div:last-child{
    position: relative;
    padding: 10px;
    padding-left: 20px;
    padding-right: 100px;
    display: flex;
    background-color: #fafafa;
  }
  .leftLogo1{
    width: 40px;
    height: 40px;
    min-width: 40px;
    vertical-align: middle;
    border-radius: 50%;
    overflow: hidden;
    margin-right: 10px;
  }
  .rightTitle1{
    /* padding-top: 4px; */
    /* line-height: 23px; */
    font-size: 14px;
    color: #008baf;
    font-weight: 600;
  }
  .rightTitle1 span{
    margin-right: 10px;
  }
  .pc_conmentContent1{
    font-size: 14px;
    line-height: 24px;
    letter-spacing:.1em;
    color: #000;
    font-weight: initial;
  }
  .del{
    position: absolute;
    right: 10px;
    bottom: 10px;
  }

    /* 详情内容 */
  .userMessage img{
    width: 30px;
    overflow: hidden;
    border-radius: 50%;
  }
  .userMessage .name{
    margin: 0 10px;
  }
  .comment{
    padding-bottom: 20px;
    border-bottom: 1px solid #aaa;
  }
  .comment>p{
    padding: 8px 14px;
  }
  .address{
    padding: 8px;
  }
  .address img{
    width: 20px;
  }
  .userImg>div{
    width: 160px;
    height: 146px;
    display: inline-block;
    padding-left: 14px;
  }
  /* 评论列表 satrt */
  .pc_conments>>>.el-dialog{
    max-width: 880px;
  }
  .area{
    width: 100%;
    max-height: 400px;
    /* height: 300px; */
    padding: 10px 20px 0;
    overflow-y: auto;
  }
  .areaItem{
    border-top: 1px dashed #aaa;
    padding: 10px 0;
    position: relative;
  }
  .areaItem:first-child{
    border: none;
  }
  .areaItem>.con{
    padding: 0 40px 10px;
    /* padding-bottom: 10px; */
    width: 100%;
  }
  .areaItem img{
    width: 34px;
    float: left;
  }
  .areaName{
    color: #6e6e6e;
    font-size: 14px;
  }
  .areaTime{
    color: #6e6e6e;
    font-size: 12px;
  }
  .areaContent{
    /* padding: 0 30px 20px; */
    font-size: 14px;
  }
  .praise{
    float: right;
    display: none;
  }
  .cancel{
    position: absolute;
    right: 2px;
    /* top: 5px; */
    bottom: 10px;
  }
  .cancel>>>.el-button{
    padding: 6px 8px;
  }
  .discussArea{
    /* border: 1px solid #aaa; */
    position: relative;
    height: 120px;
    margin: 0 4px;
    overflow: hidden;
  }
  .discuss{
    border-radius: 6px;
    border: 1px solid #dcdfe6;
    color: #606266;
    width: 100%;
    height: 100%;
    /* background-color: rgb(240, 240, 240); */
    padding: 20px;
    font-size: 14px;
    transition: border-color .2s cubic-bezier(.645,.045,.355,1);
  }
  .discuss:focus{
    outline: none;
    border-color: #409eff;
  }
  .discussArea>button{
    position: absolute;
    right: 10px;
    bottom: 2px;
    padding: 6px 18px;
    border-radius: 4px;
    outline: none;
    border: 1px solid #dcdfe6;
    background-color: white;
    /* box-shadow: 0 0 10px; */
    /* border: none; */
    cursor: pointer;
  }
  .discussArea>button:hover{
    color: #409eff;
    border-color: #409eff;
  }
  .pc_conments>>>.el-dialog--center .el-dialog__body{
    padding:25px 25px 30px;
    text-align: left;
  }
  /* 评论列表 end */

  .null{
    padding-bottom: 200px;
    text-align: center;
  }
  .null>div{
    
    width: 200px;
    margin: 20px auto;
  }
</style>